module.exports = __webpack_public_path__ + "img/sesion-terminada.602d7cbd.png";